import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
  name: "loader",
  initialState: { isShow: false, isShowUpdated: false },
  reducers: {
    loaderShow: (state, action) => {
      state.isShow = true;
    },
    loaderHide: (state, action) => {
      state.isShow = false;
    },
    setIsShowUpdated: (state, action) => {
      state.isShowUpdated = action.payload;
    },
  },
});

export const loaderActions = loaderSlice.actions;
export default loaderSlice;
